import { IUI_SettingsTable, TUISettingsCodes } from "../../../../models/index.db..model"

export const Contract_Table_Default_Settings:IUI_SettingsTable = {
  table_code:'contractTableInstance',
  rows_qty_to_cache:200,
  sort_default:'updated_at',
  page_rows_qty:50,
  fields:['all_statuses', 'open', 'pre_verified', 'verified', 'completed', 'pause', 'renegotiated', 'closed'],
  custom_fields:['Консультанты','Акты']
}
export const UI_SETTING_CODE:TUISettingsCodes = 'contractTableInstance'
export const OBJECT_COLLUMS_MAP_CONTRACT = new Map <string,string> ([
  ['child_contract', 'guid'],
  ['parent_contract_guid', ''],
  ['parent_contract_guid', 'guid'],
  ['master_project', 'master_project.name'],
  ['master_project', 'master_project.subtype'],
  ['master_project', 'master_project.type'],
])
export const CUSTOM_PROPS_TO_SHOW:string[] = []
//export const CUSTOM_PROPS_TO_SHOW = ['Консультанты','Акты','Юристы','Расторжение','Поставки','Валюты расчетов']
export const FIELDS_TO_MERGE = [['child_contract','parent_contract_guid','original_contract'],'contracts']
export const OBJECT_COLLUMS_MAP_TASK = new Map<string, string>([
    ['status_current', 'status_current.label'],
])

export const columnsToDisplayBasic: string[] = [
    'name', 'description_text', 'creator_guid', 'contracts', 'status', 'updated_at', 'created_at', 'master_project.subtype', 'master_project.type'
];
export const columnsToDisplayInterDomain: string[] = [
    'name', 'description_text', 'creator_guid', 'contracts', 'master_project.name', 'status', 'updated_at', 'created_at', 'master_project.subtype', 'master_project.type'
];
export const columnsToSelectTarget: string[] = [
  'name', 'description_text','master_project_guid', 'creator_guid', 'status', 'updated_at', 'created_at'
];
export const contractStatuses: string[] = [
    'all_statuses', 'open', 'pre_verified', 'verified', 'completed', 'pause', 'renegotiated', 'closed'
];